<template>
  <div>
    <div class="modal-mask" transition="modal">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">Категория</slot>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Название организации</label>
              <select
                class="form-control"
                :disabled="suggestion.state != 0"
                v-model="formData.orgName"
                @change="onSelectUnit"
              >
                <option
                  v-for="(unit, index) in units"
                  :key="index"
                  :value="unit.value"
                >
                  {{ unit.label }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>Комментарий к действию</label>
              <textarea
                :disabled="suggestion.state != 0"
                v-model="formData.resultText"
                type="text"
                class="form-control"
                rows="4"
              />
            </div>
            <div class="form-group">
              <label>действие</label>
              <select
                class="form-control"
                :disabled="suggestion.state != 0"
                v-model="formData.state"
              >
                <option value="1">Сделано</option>
                <option value="2">Отказано</option>
              </select>
            </div>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button
                class="modal-button btn btn-danger"
                @click="$emit('closeModal', false)"
              >
                Закрыть
              </button>
              <button
                class="modal-button btn btn-warning"
                @click="
                  suggestion.state == '0'
                    ? submitUpdate()
                    : $emit('closeModal', false)
                "
              >
                Отправить
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { POST } from "../../shared/api";

export default {
  props: ["suggestion"],
  data() {
    return {
      formData: {
        orgName:
          this.suggestion.resultText == "Запрос создан, ждет валидации"
            ? "Ushbu mahsulot mavjud (TYaMKga qo'shilgan) \n Этот товар существует (добавлен в ЕНКТ)"
            : this.suggestion.resultText,
        resultText:
          this.suggestion.resultText == "Запрос создан, ждет валидации"
            ? "Ushbu mahsulot mavjud (TYaMKga qo'shilgan) \n Этот товар существует (добавлен в ЕНКТ)"
            : this.suggestion.resultText,
        state: this.suggestion.state,
        sugg_id: this.suggestion.id,
      },
      units: [
        {
          label: "Укажите ГОСТ (ТУ, ОСТ) на товар ",
          value:
            "Tovar bo'yicha DSt (TSh, TSt)ni ko'rsating \n Укажите ГОСТ (ТУ, ОСТ) на товар",
        },
        {
          label: "Добавлена единица измерения ",
          value: "O'lchov birligi qo'shildi \n Добавлена единица измерения ",
        },
        {
          label: "Напишите полное название товара (услуги, работы) ",
          value:
            "Tovar (xizmat, ishning) to'liq nomini yozing \n Напишите полное название товара (услуги, работы)",
        },
        {
          label: "Этот товар существует (добавлен в ЕНКТ)",
          value:
            "Ushbu mahsulot mavjud (TYaMKga qo'shilgan) \n Этот товар существует (добавлен в ЕНКТ)",
        },
        {
          label: "Перенаправить в Фарм агенство ",
          value:
            "Dori preparatlarini qo'shish  savollari bo'yicha +998 90 912 8757 telegram raqamiga murojaat qilishingizni so'raymiz \n По вопросам добавления лекарственных препаратов просим вас обратиться в телеграм по номеру +998 90 912 8757",
        },
        {
          label: "ПКМ-37 ",
          value:
            "2021 yil 26 yanvardagi 37-sonli VMQga muvofiq, 2-ilova, 4-bob, 20-band, Klassifikatorga qo'shilgan tovarlar va xizmatlarning nomlari O’zbekiston Respublikasining davlat standartlari, Sanoat standarti, Texnik shartlarga mos kelishi kerak. (<a href=&quot;https://lex.uz/docs/5243631&quot;>ПКМ-37 </a>, <a href=&quot;https://prnt.sc/BgUT_cRdQ_Di&quot;> 20 band </a> ). Shu munosabat bilan, quyidagi havola orqali davlat standartlariga mos, yangi ariza qoldirishingizni so'raymiz. \n В соответствии с ПКМ 37 от 26.01.2021 Приложение 2, глава 4 пункт 20, наименования добавляемых в Классификатор товаров и услуг должны соответствовать ГОСТ, ОСТ, ТУ. (<a href=&quot;https://lex.uz/docs/5243631&quot;>ПКМ-37 </a>, <a href=&quot;https://prnt.sc/Zly47i2cPXD6&quot;> 20 пункт </a>). В связи с этим просим вас создать новую заявку с указанием ссылки на соответствующий стандарт.",
        },
        {
          label: "Товар не неайдет по ссылке ",
          value:
            "Siz ko'rsatgan havolada (https://enix.ru/categorija/gidroizolyatsionnye-materialy/rulonnaya-gidroizolyatsiya/naplavlyaemaya-gidroizolyaciya/rizolin) …. tovari haqida ha'lumot topilmadi \n По указанной вами ссылке (https://enix.ru/categorija/gidroizolyatsionnye-materialy/rulonnaya-gidroizolyatsiya/naplavlyaemaya-gidroizolyaciya/rizolin) информация о товаре (...........)  не обнаружена",
        },
        {
          label: "ПКМ-275  ",
          value:
            "Sizdan O‘zbekiston Respublikasi Vazirlar Mahkamasining 2016 yil 24 avgustdagi 275-son qarori (https://lex.uz/docs/3019920) bilan tanishib chiqishingizni so’raymiz. Mazkur qarorda O‘zbekiston Respublikasi hududida ko‘rsatiladigan xizmatlar nomlari bo‘yicha jadval taqdim etilgan. Sizga kerakli bo‘lgan xizmatning standart nomini ko‘rsatishingizni iltimos qilamiz . \n Просим вас изучить Постановление Кабинета Министров Республики Узбекистан, от 24.08.2016 г. № 275. (https://lex.uz/docs/3019920) В таблице указаны стандартные наименования услуг осуществляемые на территории Республики Узбекистан. Просим вас указать услугу в стандартном наименовании.",
        },
      ],
    };
  },
  methods: {
    submitUpdate() {
      POST(
        {
          resultText: this.formData.resultText,
          state: this.formData.state,
          sugg_id: this.formData.sugg_id,
        },
        "/suggestions?_method=PUT",
        this,
        true
      ).then((response) => {
        this.$emit("closeModal", false);
      });
    },
    onSelectUnit(e) {
      this.formData.resultText = e.target.value;
    },
  },
};
</script>
<style lang=""></style>
